/**
 * 通知
 */
const notifyMsg = {
  getNotifySmsMsg: '/api/getNotifySmsMsg',
  getNotifyMsg: '/api/getNotifyMsg', //查询站内短信
  setNotifyMsgStatusToRead: '/api/setNotifyMsgStatusToRead', //修改站内短信状态
  setAllNotifyMsgStatusToRead: '/api/setAllNotifyMsgStatusToRead', //修改站内短信状态
  pushNotifyMsgToMyProperties: '/api/pushNotifyMsgToMyProperties', //业主发布站内短信到物业
  pushNotifyMsgToMyLessees: '/api/pushNotifyMsgToMyLessees', //物业发布站内短信到租户
  getUnReadNotifyMsgCount: '/api/getUnReadNotifyMsgCount', //查询站内短信数量
  pageNotifyMsgInfoList: '/api/pageNotifyMsgInfoList', //查询站内短信列表
}

export default notifyMsg
